// This file is used for pnr related functionality
(function () {
  'use strict';
  angular.module('obex').
    factory('pnr', ['$http', 'obexConstant', 'authService',
      ($http, obexConstant, authService) => {
        return {
          processingPnr(pnrs) {
            const pnrObj = { "pnrs": pnrs };
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlProcessPnr}/gdssettingid/1`;
              console.log("process pnr: ", url, pnrObj);
              return $http.post(url, pnrObj, {
                headers: authHeader,
              });
            });
          },
        };
      },
    ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/pnr.service.js